import { createApp } from 'vue';

import OrderSearch from './components/OrderSearch.vue';
import OrderModal from './components/OrderModal.vue';
import InvoiceModal from './components/InvoiceModal.vue';

import OnlineOrders from './screens/OnlineOrders.vue';
import AccountTransactions from './screens/AccountTransactions.vue';

document.addEventListener('DOMContentLoaded', () => {
    const accountTransactionsContainer = document.getElementById('js-account-transactions');
    const onlineOrdersContainer = document.getElementById('js-online-orders');
    const orderSearchContainer = document.getElementById('js-order-search');
    const invoiceModals = document.querySelectorAll('.js-invoice-modal');

    if(accountTransactionsContainer){
        const accountTransactionsApp = createApp(AccountTransactions, {
            accountNumber: accountTransactionsContainer.getAttribute('data-account-number'),
            customerFirstName: accountTransactionsContainer.getAttribute('data-customer-first-name'),
            customerLastName: accountTransactionsContainer.getAttribute('data-customer-last-name'),
            customerEmail: accountTransactionsContainer.getAttribute('data-customer-email'),
            customerAddresses: JSON.parse(  accountTransactionsContainer.getAttribute('data-customer-addresses')),
            phoneNumber: accountTransactionsContainer.getAttribute('data-phone-number'),
            defaultBillingAddress: JSON.parse(  accountTransactionsContainer.getAttribute('data-default-billing-address')),
        });
        accountTransactionsApp.mount(accountTransactionsContainer);
    }
    if(onlineOrdersContainer){
        const onlineOrdersApp = createApp(OnlineOrders, {
            accountNumber: onlineOrdersContainer.getAttribute('data-account-number'),
        });
        onlineOrdersApp.mount(onlineOrdersContainer);
    }

    if(orderSearchContainer){
        const orderSearchApp = createApp(OrderSearch, {
            accountNumber: orderSearchContainer.getAttribute('data-account-number'),
        });
        orderSearchApp.mount(orderSearchContainer);
    }

    if(invoiceModals && invoiceModals.length){
        invoiceModals.forEach(modalContainer => {
            const modalApp = createApp(InvoiceModal, {
                poCode: modalContainer.getAttribute('data-po-code'),
                accountNumber: modalContainer.getAttribute('data-account-number'),
            });
            modalApp.mount(modalContainer);
        })
    }

    document.querySelectorAll('body.sales-order-history #my-orders-table .action.view').forEach((element, index) => {
        // Get index of element
        const orderModalContainer = document.querySelectorAll('.js-modal-container')[index].querySelector('.js-order-modal');
        const orderModalApp = createApp(OrderModal, {
            orderNumber: orderModalContainer.getAttribute('data-order-number'),
            clickTrigger: element
        });
        orderModalApp.mount(orderModalContainer);
    })

    document.querySelectorAll('.js-order-modal__close').forEach(element => {
        element.addEventListener('click', (e) => {
            e.preventDefault();
            // Get closest tr and find element within with class js-order-modal
            const orderModal = e.target.closest('.js-order-modal').classList.remove('is-active');
        });
        
    })
});

